import { render, staticRenderFns } from "./indexLawton.vue?vue&type=template&id=3daaf746&"
import script from "./indexLawton.vue?vue&type=script&lang=js&"
export * from "./indexLawton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports